import { render, staticRenderFns } from "./TableStats.vue?vue&type=template&id=b6dc5154&scoped=true&"
import script from "./TableStats.vue?vue&type=script&lang=js&"
export * from "./TableStats.vue?vue&type=script&lang=js&"
import style0 from "./TableStats.vue?vue&type=style&index=0&id=b6dc5154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dc5154",
  null
  
)

export default component.exports